import PropTypes from 'prop-types';

const analyticsPropType = PropTypes.shape({
	shouldTrackClicks: PropTypes.bool,
	content_block: PropTypes.string,
	event: PropTypes.string,
});

export default analyticsPropType;
